import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { FabiJobSearchQueryGenerationUseCase } from '@xing-com/crate-common-graphql-types';
import { useMatchMedia } from '@xing-com/crate-hooks-use-match-media';
import {
  IconAICareerChanger,
  IconAIFilled,
  IconAIProfileSearch,
} from '@xing-com/icons';
import { mediaConfined, mediaSmallOrTiny } from '@xing-com/layout-tokens';
import { Marker } from '@xing-com/marker';
import { spaceXS, spaceXXS } from '@xing-com/tokens';
import { BodyCopy, Meta } from '@xing-com/typography';

const SIZE = 24;
const SMALL_SIZE = 18;

const CASES = {
  [FabiJobSearchQueryGenerationUseCase.SearchWithProfile]: {
    title: 'JOBS_SEARCH_AI_SWIMP_SUGGESTION',
    subtitle: 'JOBS_SEARCH_AI_SWIMP_SUGGESTION_SUBTITLE',
    Icon: IconAIProfileSearch,
  },
  [FabiJobSearchQueryGenerationUseCase.SearchWithSkills]: {
    title: 'JOBS_SEARCH_AI_SWIMS_SUGGESTION',
    subtitle: 'JOBS_SEARCH_AI_SWIMS_SUGGESTION_SUBTITLE',
    Icon: IconAICareerChanger,
  },
};

type Props = {
  useCase: FabiJobSearchQueryGenerationUseCase;
};
export const InstantPrompt: React.FC<Props> = ({ useCase }) => {
  const isSmall = useMatchMedia(mediaSmallOrTiny);

  const { title, subtitle, Icon } = CASES[useCase];
  const iconSize = isSmall ? SMALL_SIZE : SIZE;
  const isNew = true; // TODO: remove in JSR-4829, add in JSR-4835

  return (
    <Container>
      <StyledIcon as={Icon} width={iconSize} height={iconSize} />
      <SuggestionText>
        <SuggestionTitle>
          <SuggestionBodyCopy size="large" noMargin lineHeight="dense">
            <FormattedMessage id={title} />
          </SuggestionBodyCopy>
          {isNew ? (
            <Marker icon={IconAIFilled} variant="strong" aria-hidden="true">
              <FormattedMessage id="XDS_FLAG_NEW_NEUTRAL" />
            </Marker>
          ) : null}
        </SuggestionTitle>
        {subtitle ? (
          <SuggestionSubtitle size="small" noMargin>
            <FormattedMessage id={subtitle} />
          </SuggestionSubtitle>
        ) : null}
      </SuggestionText>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  gap: 10px;
`;

const StyledIcon = styled.div`
  flex-shrink: 0;
`;

const SuggestionText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  gap: ${spaceXXS};
`;

const SuggestionTitle = styled.div`
  display: flex;
  gap: ${spaceXS};
  align-items: start;
  justify-content: space-between;
  width: 100%;

  @media ${mediaConfined} {
    align-items: center;
    justify-content: start;
  }
`;

const SuggestionBodyCopy = styled(BodyCopy)`
  text-wrap: balance;
`;

const SuggestionSubtitle = styled(Meta)`
  text-wrap: balance;
`;
